import { useContext } from 'react';
import { ThemeContext } from '../../../../context/ThemeContext';
import { TruncateText } from '../../../../utils/TruncateText';
import { Link } from 'react-router-dom';
import { Box, Divider, Grid, useMediaQuery, useTheme } from '@mui/material'
import HighlightText from '../../../../utils/HighlightText';
import image from '../../../../assets/images/common/Reports_CoverPage.jpg'

import {
  StyledContainer,
  StyledPaper,
  ImageContainer,
  ContentBox,
  TitleText,
  InfoText,
  InfoItem,
  ActionBox,
  PriceText,
  RequestButton,
  BuyButton
} from './Styles_ReportCard';


function ReportCard({ title, info, price, reportCode, publishedOn, pages, category }) {

  const { inputValue, setOpenPopUp } = useContext(ThemeContext);

  const theme = useTheme();
  const isLaptop = useMediaQuery(theme.breakpoints.down('xxl')); // Mobile screen check
  const isMobile = useMediaQuery(theme.breakpoints.down('mdlg')); // Mobile screen check
  
  const infoLimit = isMobile ? 200 : isLaptop ? 300 : 350;
  const truncatedInfo = TruncateText(info, infoLimit);
  const highlightedTitle = HighlightText(title, inputValue);
  
  return (
    <StyledContainer>
      <StyledPaper>
        
        {/* Image  */}
        <ImageContainer>
          <Box component="img" src={image} sx={{ width: '100%', height: '100%' }} />
        </ImageContainer>

        {/* Title and Info */}
        <ContentBox>
          <Link onClick={() => setOpenPopUp(true)} style={{ textDecoration: 'none' }} >
            <TitleText>{highlightedTitle}</TitleText>
          </Link>
          <InfoText>{truncatedInfo}</InfoText>

          {/* Other Info */}
          <Grid container spacing={1} justifyContent="space-between" sx={{ width: '100%', height: '15%' }} >
            <InfoItem><b>Report Code:</b> {reportCode}</InfoItem>
            <InfoItem sx={{ width: { xs: '52%', md: '60%', xl: '47%' } }} ><b>Published On</b>: {publishedOn}</InfoItem>
            <InfoItem><b>Pages</b>: {pages}</InfoItem>
            <InfoItem sx={{ width: { xs: '52%', md: '60%', xl: '47%' } }} ><b>Category:</b> {category}</InfoItem>
          </Grid>
        </ContentBox>

        <Divider orientation="vertical" variant="middle" flexItem sx={{ display: { xs: 'none', md: 'flex' }, bgcolor: '#f4f4fa'}} />
        
        {/* Buttons */}
        <ActionBox>
          <PriceText>Price:<b> {price}</b></PriceText>
          <Link onClick={() => setOpenPopUp(true)} >
            <RequestButton variant='contained' >Request Sample</RequestButton>
          </Link>
          <Link onClick={() => setOpenPopUp(true)} >
            <BuyButton variant='contained' >Buy Now</BuyButton>
          </Link>
        </ActionBox>
      </StyledPaper>
    </StyledContainer>
  )
}

export default ReportCard
